export const translations = {
  'Database backups': 'データベースのバックアップ',
  'Run backup now': '今すぐバックアップ',
  'Queuing backup…': 'バックアップを登録中…',
  'Create a full database backup in the private db-backup container. Queued jobs are not completed backups.':
    '非公開の db-backup コンテナーにデータベース全体をバックアップします。待機中のジョブは完了済みのバックアップではありません。',
  'View backup audit log': 'バックアップの監査ログを表示',
  'Backup queued. Waiting for a worker.':
    'バックアップを登録しました。ワーカーの処理開始を待っています。',
  'Backup in progress. Uploading may take several minutes.':
    'バックアップを実行中です。アップロードには数分かかる場合があります。',
  'Backup completed and uploaded to db-backup.':
    'バックアップが完了し、db-backup にアップロードされました。',
  'Backup failed. See the error and audit log.':
    'バックアップに失敗しました。エラーと監査ログをご確認ください。',
  'No backup jobs yet': 'バックアップジョブはまだありません',
  'Backup history': 'バックアップ履歴',
  'Job ID': 'ジョブID',
  Trigger: '実行方法',
  'Requested at': '要求日時',
  'Finished at': '終了日時',
  'Size / error': 'サイズ / エラー',
  '{count} bytes': '{count} バイト',
  'Backup requested': 'バックアップ要求',
  'Backup completed': 'バックアップ完了',
  'Backup failed': 'バックアップ失敗',
  'Backup job': 'バックアップジョブ',
  Scheduled: 'スケジュール実行',
  Manual: '手動実行',
  'Operations command': '運用コマンド',
  Details: '詳細',
  'API changes and database backup requests and outcomes, in chronological order.':
    'APIによる変更とデータベースのバックアップ要求・結果を時系列で表示します。',
  'Switch to Japanese': '日本語に切り替え',
  'Switch to English': '英語に切り替え',
  'Language preference is unavailable. Your selection applies only to this visit.':
    '言語設定を保存できません。選択した言語は今回のアクセス中のみ有効です。',
  'Quality analytics and defect reporting portal.': '品質分析・欠陥報告ポータル。',
  'Paint Defect Inspection Platform': '塗装欠陥検査プラットフォーム',
  'QUALITY / DELIVERY / TRUST': '品質 / 納期 / 信頼',
  'Protecting quality through every process.': 'すべての工程で品質を守ります。',
  'QUALITY OPERATIONS': '品質管理業務',
  'Sanwa Kenko': '三和建興',
  'SANWA KENKO': '三和建興',
  'Sign in with your back-office account to continue.':
    '管理ポータルのアカウントでログインしてください。',
  'Username or email': 'ユーザー名またはメールアドレス',
  Password: 'パスワード',
  'Sign in': 'ログイン',
  'Signing in…': 'ログイン中…',
  'Sign-in failed. Check your username or email and password.':
    'ログインできませんでした。ユーザー名またはメールアドレスとパスワードをご確認ください。',
  'Sign out': 'ログアウト',
  'My account': 'マイアカウント',
  'Change your initial password before continuing.':
    '続行する前に初期パスワードを変更してください。',
  'Change password': 'パスワード変更',
  'Current password': '現在のパスワード',
  'New password': '新しいパスワード',
  'Could not change your password. Check the current password and use a different new password of at least 12 characters.':
    'パスワードを変更できませんでした。現在のパスワードを確認し、12文字以上の異なる新しいパスワードを指定してください。',
  'Quality Operations Portal': '品質管理ポータル',
  'Quality assurance workspace': '品質保証ワークスペース',
  Primary: 'メインナビゲーション',
  Operations: '業務',
  Administration: '管理',
  Dashboard: 'ダッシュボード',
  Overview: '概要',
  Inspections: '検査',
  'Saved scans & review': '保存済みスキャンとレビュー',
  Analytics: '分析',
  'Scans & corrections': 'スキャンと修正',
  'Export Center': 'エクスポートセンター',
  'Review Categories': 'レビューカテゴリ',
  'Correction choices': '修正の選択肢',
  'Audit Log': '監査ログ',
  'System activity': 'システムの操作履歴',
  Users: 'ユーザー',
  'Access management': 'アクセス管理',
  'Skip to main content': 'メインコンテンツへ移動',
  'QUALITY CONTROL / OVERVIEW': '品質管理 / 概要',
  'Saved inspection overview': '保存済み検査の概要',
  'For this release, each successfully saved inference is one inspection, including scans with no detections. Figures cover retained history only.':
    '本リリースでは、検出のないスキャンも含め、正常に保存された推論1件を検査1件として扱います。数値は保持されている履歴のみを対象とします。',
  'Inspection counts': '検査件数',
  'Saved inspections': '保存済み検査',
  'With detections': '検出あり',
  'Model found at least one defect': 'モデルが1件以上の欠陥を検出',
  'Total detections': '総検出数',
  'Reviewed inspections': 'レビュー済み検査',
  'At least one human review': '人によるレビューが1件以上',
  'Inspection activity': '検査の推移',
  'No saved inspections yet': '保存済み検査はまだありません',
  'Recent inspections': '最近の検査',
  'View all': 'すべて表示',
  'Recent saved inspections': '最近保存された検査',
  Completed: '完了日時',
  Model: 'モデル',
  Detections: '検出数',
  Reviews: 'レビュー数',
  'Inspection Analytics': '検査分析',
  'Every saved inference is one inspection. Model detections and human correction categories are reported separately.':
    '保存された推論1件を検査1件として扱います。モデルによる検出と人による修正カテゴリは別々に集計されます。',
  From: '開始日',
  To: '終了日',
  'The start date must not be later than the end date.': '開始日は終了日以前にしてください。',
  'Scan totals': 'スキャン集計',
  '{saved} saved inspections · {withDetections} with detections · {detections} detections · {reviewed} reviewed':
    '保存済み検査 {saved}件 · 検出あり {withDetections}件 · 検出数 {detections}件 · レビュー済み {reviewed}件',
  'Activity over time': '時系列の推移',
  'No inspections in this range': 'この期間の検査はありません',
  'By model version': 'モデルバージョン別',
  'No model data': 'モデルデータがありません',
  Unknown: '不明',
  'Human correction categories': '人による修正カテゴリ',
  'Current incorrect reviews with a selected category; these are not model predictions.':
    'カテゴリが選択されている現在の「不正確」レビューを集計します。モデルの予測ではありません。',
  'No categorised corrections yet': 'カテゴリ付きの修正はまだありません',
  Group: 'グループ',
  Category: 'カテゴリ',
  Corrections: '修正件数',
  'Correction target progress': '修正目標の進捗',
  'Defects corrected to the selected category compared with the configured target.':
    '選択したカテゴリに修正された不具合数と、設定された目標との比較です。',
  'No enabled correction categories': '有効な修正カテゴリがありません',
  '{count} of {target} corrected': '{target}件中 {count}件 修正済み',
  '{count} of {target} defects corrected ({percent}%)':
    '不具合 {target}件中 {count}件 修正済み（{percent}%）',
  'Download one row per prediction with the owner username, label and confidence. Inspections with no detections are included.':
    '予測ごとに所有者のユーザー名、ラベル、信頼度を含む1行をダウンロードします。検出のない検査も含まれます。',
  'Saved inspection exports': '保存済み検査のエクスポート',
  'Inference extraction for retraining': '再学習用の推論データ抽出',
  'Inference extraction': '推論データ抽出',
  'Download a ZIP containing the original scanned images and result.json files enriched with user feedback and detection review history.':
    '元のスキャン画像と、ユーザーのフィードバックおよび検出レビューの履歴を追加した result.json をZIP形式でダウンロードします。',
  'Extraction from': '抽出開始日',
  'Extraction to': '抽出終了日',
  'Extraction day': '抽出日',
  'Start time': '開始時刻',
  'End time': '終了時刻',
  'Times use your browser timezone: {timezone}.':
    '時刻はブラウザーのタイムゾーン（{timezone}）で指定します。',
  'Select a day and both times. Inference completion times include the start and exclude the end.':
    '日付と開始・終了時刻を指定してください。推論の完了時刻が開始時刻以上、終了時刻未満のデータを含みます。',
  'The end time must be later than the start time.': '終了時刻は開始時刻より後にしてください。',
  'The selected time does not exist in your browser timezone.':
    '選択した時刻はブラウザーのタイムゾーンに存在しません。',
  'Model version (optional)': 'モデルバージョン（任意）',
  'User feedback': 'ユーザーのフィードバック',
  'All feedback states': 'すべてのフィードバック状態',
  'With user feedback': 'ユーザーのフィードバックあり',
  'Without user feedback': 'ユーザーのフィードバックなし',
  'Only retained, saved inferences are included. For large datasets, download smaller date ranges.':
    '保存期間内の保存済み推論のみを含みます。データ量が多い場合は期間を分けてダウンロードしてください。',
  'Only retained, saved inferences are included. For large datasets, download smaller time windows.':
    '保存期間内の保存済み推論のみを含みます。データ量が多い場合は時間帯を分けてダウンロードしてください。',
  'Preparing inference ZIP…': '推論データのZIPを準備中…',
  'Download inference ZIP': '推論データのZIPをダウンロード',
  'Inference ZIP prepared. Your download has started.':
    '推論データのZIPを準備しました。ダウンロードを開始しました。',
  'Could not extract inferences.': '推論データを抽出できませんでした。',
  'Export format': 'エクスポート形式',
  'CSV (.csv)': 'CSV形式 (.csv)',
  'Excel (.xlsx)': 'Excel形式 (.xlsx)',
  'Word (.docx)': 'Word形式 (.docx)',
  'PDF (.pdf)': 'PDF形式 (.pdf)',
  'Excel contains the same columns as CSV. Word contains an editable table. PDF includes the table and the Activity over time chart for this date range.':
    'ExcelにはCSVと同じ列が含まれます。Wordには編集可能な表が含まれます。PDFには表と、この期間の「時系列の活動」グラフが含まれます。',
  'Preparing…': '準備中…',
  'Download CSV': 'CSVをダウンロード',
  'Download Excel': 'Excelをダウンロード',
  'Download Word': 'Wordをダウンロード',
  'Download PDF': 'PDFをダウンロード',
  'Could not export inspections.': '検査をエクスポートできませんでした。',
  'Inspections · Scan review': '検査 · スキャンレビュー',
  'Each saved inference is an inspection. Review its image and correct individual detections.':
    '保存された推論1件を検査1件として扱います。画像を確認し、個々の検出を修正してください。',
  'Use the thumbnails to find scans that need review. Select an image to review it.':
    'サムネイルでレビューが必要なスキャンを探してください。画像を選択するとレビューできます。',
  Image: '画像',
  'Saved scan thumbnail': '保存済みスキャンのサムネイル',
  'Review scan {id}': 'スキャン {id} をレビュー',
  'Image unavailable': '画像を表示できません',
  'Loading scans…': 'スキャンを読み込み中…',
  'No saved scans in this range': 'この期間の保存済みスキャンはありません',
  Saved: '保存日時',
  'Inspected by': '検査担当者',
  'Inspected by {username}': '検査担当者: {username}',
  'Reviewed by {username}': 'レビュー担当者: {username}',
  Incorrect: '不正確',
  Review: 'レビュー',
  'Scan review': 'スキャンレビュー',
  'Close scan': 'スキャンを閉じる',
  'Loading scan…': 'スキャンを読み込み中…',
  'Scan {id}': 'スキャン {id}',
  Pending: '待機中',
  Running: '処理中',
  'Completed export': 'エクスポート完了',
  Failed: '失敗',
  'Unknown model': '不明なモデル',
  '{count} detections': '検出数 {count}件',
  'Saved scan for review': 'レビュー用の保存済みスキャン',
  'Detection boxes': '検出枠',
  'Detection #{number}': '検出 #{number}',
  'Class {id}': 'クラス {id}',
  'Your review:': '自分のレビュー:',
  'Other reviewer:': '他のレビュアー:',
  'Missed defects': '未検出の欠陥',
  'Add a separate entry for each defect the model did not detect.':
    'モデルが検出しなかった欠陥ごとに、個別の項目を追加してください。',
  'Your missed defect:': '自分が報告した未検出の欠陥:',
  'Other reviewer missed defect:': '他のレビュアーが報告した未検出の欠陥:',
  'Unknown category': '不明なカテゴリ',
  'Add missed defect': '未検出の欠陥を追加',
  'Review history ({count})': 'レビュー履歴 ({count}件)',
  'Detection assessment': '検出の評価',
  Correct: '正確',
  Reason: '理由',
  'Select reason…': '理由を選択…',
  'Wrong category': 'カテゴリの誤り',
  'No defect (false positive)': '欠陥なし（誤検出）',
  'Incorrect box / location': '検出枠・位置の誤り',
  'Duplicate detection': '重複検出',
  'Missed defect': '未検出の欠陥',
  'Correct defect category': '正しい欠陥カテゴリ',
  'Correct defect category (optional)': '正しい欠陥カテゴリ（任意）',
  'Select category…': 'カテゴリを選択…',
  'Note (optional)': 'メモ（任意）',
  'Saving…': '保存中…',
  'Save revision': '修正版を保存',
  'Save review': 'レビューを保存',
  'Cancel missed defect': '未検出の欠陥の追加をキャンセル',
  'Review saved.': 'レビューを保存しました。',
  'Super Admin · Users': '最高管理者 · ユーザー',
  'Create shared accounts, choose mobile and back-office access, or deactivate accounts.':
    '共通アカウントを作成し、モバイル・管理ポータルへのアクセスを設定するか、アカウントを無効化します。',
  'Add user': 'ユーザーを追加',
  'New username': '新規ユーザー名',
  Username: 'ユーザー名',
  'New user name': '新規ユーザーの氏名',
  Name: '名前',
  'New user email optional': '新規ユーザーのメールアドレス（任意）',
  'Email (optional)': 'メールアドレス（任意）',
  'Initial password': '初期パスワード',
  'New user role': '新規ユーザーの権限',
  User: 'ユーザー',
  Admin: '管理者',
  'Super admin': '最高管理者',
  Mobile: 'モバイル',
  'Back office': '管理ポータル',
  Inference: '推論',
  'No users found': 'ユーザーが見つかりません',
  Email: 'メールアドレス',
  Role: '権限',
  Active: '有効',
  Inactive: '無効',
  Remove: '削除',
  'Reset password': 'パスワードをリセット',
  'Last login': '最終ログイン',
  'Role for {name}': '{name}の権限',
  'Active for {name}': '{name}の有効状態',
  'Mobile access for {name}': '{name}のモバイルアクセス',
  'Back-office access for {name}': '{name}の管理ポータルアクセス',
  'Inference for {name}': '{name}の推論権限',
  'New password for {name}': '{name}の新しいパスワード',
  Deactivate: '無効化',
  Activate: '有効化',
  Save: '保存',
  Reset: 'リセット',
  'Change required': '変更が必要',
  'Admin · Audit Log': '管理者 · 監査ログ',
  'Every create/update/delete performed through the API, in chronological order.':
    'API経由で行われたすべての作成・更新・削除を時系列順に表示します。',
  'Entity type': 'エンティティ種別',
  'e.g. inspection, order, user': '例: inspection（検査）, order（注文）, user（ユーザー）',
  Action: '操作',
  'Any action': 'すべての操作',
  Create: '作成',
  Update: '更新',
  Delete: '削除',
  'No audit events found': '監査イベントが見つかりません',
  'Audit log': '監査ログ',
  Timestamp: '日時',
  Actor: '操作主体',
  Entity: 'エンティティ',
  'Entity ID': 'エンティティID',
  system: 'システム',
  'Admin · Review categories': '管理者 · レビューカテゴリ',
  'Manage human correction choices. Model predictions and inspection defect types are separate.':
    '人による修正の選択肢を管理します。モデルの予測と検査の欠陥種別は別に管理されます。',
  'Category groups': 'カテゴリグループ',
  'The initial group is Defect. Additional groups can be added for future review workflows.':
    '初期グループは「欠陥」です。今後のレビューワークフローに向けてグループを追加できます。',
  Code: 'コード',
  'Add group': 'グループを追加',
  'Select…': '選択…',
  'Add choice': '選択肢を追加',
  Choice: '選択肢',
  Status: '状態',
  'Group inactive': 'グループが無効',
  Defect: '欠陥',
  'Bumps & blemishes': '突起・表面不良',
  'Color-related': '色関連',
  Sags: 'たれ',
  'Scratches & dents': '傷・へこみ',
  Wrinkles: 'しわ',
  'Browse, filter, and drill into individual inspection records.':
    '検査記録を一覧表示・絞り込みし、個々の詳細を確認できます。',
  Captured: '撮影日時',
  Verdict: '判定',
  Confidence: '信頼度',
  Device: 'デバイス',
  Location: '場所',
  'No inspections match these filters': 'この条件に一致する検査はありません',
  'Try widening your date range or clearing filters.':
    '期間を広げるか、フィルターを解除してください。',
  'Filter inspections': '検査を絞り込み',
  Order: '注文',
  'All orders': 'すべての注文',
  'Process / Station': '工程 / ステーション',
  'All processes': 'すべての工程',
  Product: '製品',
  'All products': 'すべての製品',
  Operator: '作業者',
  'All operators': 'すべての作業者',
  'Defect Type': '欠陥種別',
  'All defect types': 'すべての欠陥種別',
  'Any verdict': 'すべての判定',
  PASS: '合格',
  FAIL: '不合格',
  Severity: '重大度',
  'Any severity': 'すべての重大度',
  MINOR: '軽微',
  MAJOR: '重大',
  CRITICAL: '致命的',
  'Date from': '開始日',
  'Date to': '終了日',
  'Min. confidence': '最低信頼度',
  'Clear filters': 'フィルターを解除',
  'Last 7 days': '過去7日間',
  'Last 30 days': '過去30日間',
  'Last 90 days': '過去90日間',
  'All time': '全期間',
  'Date range presets': '期間のプリセット',
  'Defect capture with bounding-box overlays': '検出枠を重ねた欠陥画像',
  'Close inspection detail': '検査詳細を閉じる',
  'Inspection detail': '検査詳細',
  'Close detail drawer': '詳細パネルを閉じる',
  'Captured at': '撮影日時',
  'Overall confidence': '全体の信頼度',
  Notes: 'メモ',
  'Defect photos ({count})': '欠陥画像 ({count}枚)',
  'Defect capture': '欠陥画像',
  'Defect findings ({count})': '検出された欠陥 ({count}件)',
  'No findings recorded': '検出結果は記録されていません',
  'Confidence:': '信頼度:',
  'Area:': '面積:',
  'Bounding box at x={x}, y={y}, width={width}, height={height}':
    '検出枠 x={x}, y={y}, 幅={width}, 高さ={height}',
  'Admin · Reference Data': '管理者 · マスターデータ',
  'Manage orders, processes, products, operators, and the defect taxonomy.':
    '注文・工程・製品・作業者・欠陥分類を管理します。',
  'Reference data resource': 'マスターデータの種類',
  Orders: '注文',
  'Order code': '注文コード',
  'Due date': '納期',
  Customer: '顧客',
  Processes: '工程',
  'Process code': '工程コード',
  Station: 'ステーション',
  'Seq.': '順序',
  'Sequence no.': '順序番号',
  Products: '製品',
  Substrate: '下地',
  'Display name': '表示名',
  'Paint spec': '塗装仕様',
  Operators: '作業者',
  Shift: 'シフト',
  'Operator code': '作業者コード',
  'Defect Types': '欠陥種別',
  'Default severity': '既定の重大度',
  Surface: '表面',
  Contamination: '汚染',
  Application: '塗布',
  Coverage: '被覆',
  Description: '説明',
  Customers: '顧客',
  'Add order': '注文を追加',
  'Add process': '工程を追加',
  'Add product': '製品を追加',
  'Add operator': '作業者を追加',
  'Add defect type': '欠陥種別を追加',
  'Add customer': '顧客を追加',
  'Create {resource}': '{resource}を作成',
  'No records yet': '記録はまだありません',
  Actions: '操作',
  'Delete this record?': 'この記録を削除しますか？',
  'Delete this group? This cannot be undone.': 'このグループを削除しますか？この操作は元に戻せません。',
  'Delete the group’s correction choices first.': '先にこのグループの修正選択肢を削除してください。',
  'Delete this correction choice? This cannot be undone.':
    'この修正選択肢を削除しますか？この操作は元に戻せません。',
  'Saved inspections and inspections with detections over time':
    '保存済み検査と検出ありの検査の時系列推移',
  'Daily saved inspections': '日別の保存済み検査',
  Day: '日',
  Week: '週',
  'Fail rate trend chart, grouped by {period}': '{period}別の不合格率の推移グラフ',
  'Fail rate trend by {period}': '{period}別の不合格率の推移',
  'Fail rate': '不合格率',
  Period: '期間',
  'Total inspections': '総検査数',
  'Fail count': '不合格数',
  'Defects by process/station bar chart': '工程・ステーション別の欠陥棒グラフ',
  Pass: '合格',
  Fail: '不合格',
  'Defects by process/station': '工程・ステーション別の欠陥',
  Process: '工程',
  Total: '合計',
  'Avg confidence': '平均信頼度',
  'Top defect types by frequency bar chart': '発生頻度別の上位欠陥種別の棒グラフ',
  Findings: '検出結果',
  'Top defect types by frequency': '発生頻度別の上位欠陥種別',
  'Defect type': '欠陥種別',
  'Finding count': '検出数',
  'Defect severity distribution donut chart': '欠陥の重大度分布のドーナツグラフ',
  'No findings in range': 'この期間の検出結果はありません',
  'Defect severity distribution': '欠陥の重大度分布',
  Pagination: 'ページ切り替え',
  'Showing {from}–{to} of {total}': '全{total}件中 {from}〜{to}件を表示',
  'Previous page': '前のページ',
  '← Prev': '← 前へ',
  'Page {page} / {totalPages}': 'ページ {page} / {totalPages}',
  'Next page': '次のページ',
  'Next →': '次へ →',
  'Nothing here yet': 'まだデータがありません',
  'Loading…': '読み込み中…',
  'Loading content': 'コンテンツを読み込み中',
  'Loading KPIs': '主要指標を読み込み中',
  'Loading chart': 'グラフを読み込み中',
  'Loading table': '表を読み込み中',
  'Refreshing your session…': 'セッションを更新中…',
  'Loading your profile…': 'プロフィールを読み込み中…',
  'Checking permissions…': '権限を確認中…',
  '403 — Forbidden': '403 — アクセス権限がありません',
  "You don't have permission to view this page. This area is restricted to Admin users.":
    'このページを表示する権限がありません。このエリアは管理者専用です。',
  "You don't have permission to view this page. Contact an administrator if you believe this is an error.":
    'このページを表示する権限がありません。誤りと思われる場合は管理者にお問い合わせください。',
  'Back to Dashboard': 'ダッシュボードに戻る',
  '404 — Page not found': '404 — ページが見つかりません',
  "The page you're looking for doesn't exist.": 'お探しのページは存在しません。',
  App: 'アプリ',
  Page: 'ページ',
  'This section': 'このセクション',
  '{section} failed to render': '{section}を表示できませんでした',
  'This section failed to render.': 'このセクションを表示できませんでした。',
  'Try again': '再試行',
  'Something went wrong': 'エラーが発生しました',
  'Trace ID:': 'トレースID:',
  'An unexpected error occurred.': '予期しないエラーが発生しました。',
  'Network Error': 'ネットワークエラー',
  'Network error': 'ネットワークエラー',
  'Request Failed': 'リクエスト失敗',
  'Request failed': 'リクエスト失敗',
  'Unable to reach the server. Check your connection and try again.':
    'サーバーに接続できません。接続を確認して再試行してください。',
  'The request could not be completed.': 'リクエストを完了できませんでした。',
  'Please sign in again.': '再度ログインしてください。',
  'You do not have permission to perform this action.': 'この操作を行う権限がありません。',
  'The requested record was not found.': '指定された記録が見つかりません。',
  'This change conflicts with the current record.': 'この変更は現在の記録と競合しています。',
  'This record has expired.': 'この記録は有効期限が切れています。',
  'Check the entered values and try again.': '入力内容を確認して再試行してください。',
  'The server could not complete the request. Try again later.':
    'サーバーがリクエストを完了できませんでした。後でもう一度お試しください。',
} as const;

export type MessageKey = keyof typeof translations;
type Placeholder<S extends string> = S extends `${string}{${infer Name}}${infer Rest}`
  ? Name | Placeholder<Rest>
  : never;

export type Language = 'en' | 'ja';
type MessageArgs<K extends MessageKey> = [Placeholder<K>] extends [never]
  ? []
  : [values: Readonly<Record<Placeholder<K>, string | number>>];

function translate<K extends MessageKey>(
  language: Language,
  key: K,
  ...args: MessageArgs<K>
): string {
  const values: Readonly<Record<string, string | number>> | undefined = args[0];
  const interpolate = (text: string) =>
    text.replace(/\{([^}]+)\}/g, (_, name: string) => {
      const value = values?.[name];
      if (value === undefined) throw new Error(`Missing translation parameter: ${name}`);
      return String(value);
    });
  return interpolate(language === 'ja' ? translations[key] : key);
}

const valueLabels: Readonly<Record<string, StaticMessageKey>> = {
  user: 'User',
  admin: 'Admin',
  super_admin: 'Super admin',
  correct: 'Correct',
  incorrect: 'Incorrect',
  wrong_category: 'Wrong category',
  false_positive: 'No defect (false positive)',
  inaccurate_box: 'Incorrect box / location',
  duplicate: 'Duplicate detection',
  missed_defect: 'Missed defect',
  create: 'Create',
  update: 'Update',
  delete: 'Delete',
  'admin.backup.request': 'Backup requested',
  'admin.backup.completed': 'Backup completed',
  'admin.backup.failed': 'Backup failed',
  'inference_extraction.completed': 'Inference extraction',
  backup_job: 'Backup job',
  scheduled: 'Scheduled',
  manual: 'Manual',
  command: 'Operations command',
  inspection: 'Inspections',
  order: 'Order',
  process: 'Process',
  product: 'Product',
  operator: 'Operator',
  defect: 'Defect',
  saved: 'Saved',
  pending: 'Pending',
  running: 'Running',
  completed: 'Completed export',
  failed: 'Failed',
  bumps_blemishes: 'Bumps & blemishes',
  color_related: 'Color-related',
  sags: 'Sags',
  scratches_dents: 'Scratches & dents',
  wrinkles: 'Wrinkles',
};

export type StaticMessageKey = {
  [K in MessageKey]: [Placeholder<K>] extends [never] ? K : never;
}[MessageKey];

function isStaticMessageKey(value: string): value is StaticMessageKey {
  return Object.hasOwn(translations, value) && !value.includes('{');
}

export function createTranslator(language: Language) {
  function t<K extends MessageKey>(key: K, ...args: MessageArgs<K>): string {
    return translate(language, key, ...args);
  }

  function displayValue(value: string): string {
    const key = valueLabels[value] ?? value;
    return isStaticMessageKey(key) ? t(key) : value;
  }

  function errorText(message: string, status?: number): string {
    if (isStaticMessageKey(message)) return t(message);
    const guidance: Partial<Record<number, StaticMessageKey>> = {
      0: 'Unable to reach the server. Check your connection and try again.',
      401: 'Please sign in again.',
      403: 'You do not have permission to perform this action.',
      404: 'The requested record was not found.',
      409: 'This change conflicts with the current record.',
      410: 'This record has expired.',
      422: 'Check the entered values and try again.',
    };
    const key =
      status !== undefined && status >= 500
        ? 'The server could not complete the request. Try again later.'
        : (guidance[status ?? -1] ?? 'The request could not be completed.');
    return `${t(key)} (${message})`;
  }

  return { t, displayValue, errorText };
}

export type Translator = ReturnType<typeof createTranslator>;
export const { t, displayValue, errorText } = createTranslator('en');
